import { render, staticRenderFns } from "./PaymentSidebar.vue?vue&type=template&id=3c289fa2&scoped=true&"
import script from "./PaymentSidebar.vue?vue&type=script&lang=ts&"
export * from "./PaymentSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c289fa2",
  null
  
)

export default component.exports